
export default {
  install: (Vue) => {
    async function copySelfToClipboard(text) {
      try {
        await navigator.clipboard.writeText(text);
        Vue.prototype.$notifyUserInteraction.info('in Zwischenablage kopiert!');
      } catch (err) {
        console.error('Clipboard write failed:', err);
        Vue.prototype.$notifyUserInteraction.error('Konnte nicht kopiert werden!');
      }
    }
    Vue.prototype.$copy = copySelfToClipboard;
  },
};
